import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

type Portal = "admin" | "empresa" | "aluno";

const MESSAGES: Record<Portal, string> = {
  admin: "Deslogado com sucesso",
  empresa: "Você saiu da sua conta",
  aluno: "Você saiu da sua conta",
};

const LOGIN_ROUTES: Record<Portal, string> = {
  admin: "/admin/login",
  empresa: "/empresa/login",
  aluno: "/aluno/login",
};

export function useLogout(portal: Portal) {
  const navigate = useNavigate();

  return async () => {
    await supabase.auth.signOut();
    toast({ title: MESSAGES[portal] });
    navigate(LOGIN_ROUTES[portal], { replace: true });
  };
}
